import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat'
})
export class PhoneFormatPipe implements PipeTransform {

  transform(phone: string): string {
    if (!phone) return '';
    
    // Eliminar espacios existentes
    let cleaned = phone.replace(/\s/g, '');
    
    // Si empieza con +34 (España)
    if (cleaned.startsWith('+34')) {
      const countryCode = '+34';
      const number = cleaned.substring(3);
      
      // Formatear: +34 666 777 888
      if (number.length === 9) {
        return `${countryCode} ${number.substring(0, 3)} ${number.substring(3, 6)} ${number.substring(6, 9)}`;
      }
    }
    
    // Si empieza con +1 (USA/Canadá)
    if (cleaned.startsWith('+1')) {
      const countryCode = '+1';
      const number = cleaned.substring(2);
      
      // Formatear: +1 (666) 777-8888
      if (number.length === 10) {
        return `${countryCode} (${number.substring(0, 3)}) ${number.substring(3, 6)}-${number.substring(6, 10)}`;
      }
    }
    
    // Si empieza con + y otro código de país
    if (cleaned.startsWith('+')) {
      const match = cleaned.match(/^(\+\d{1,3})(\d+)$/);
      if (match) {
        const countryCode = match[1];
        const number = match[2];
        
        // Formatear en grupos de 3: +XX XXX XXX XXX
        const formatted = number.match(/.{1,3}/g)?.join(' ') || number;
        return `${countryCode} ${formatted}`;
      }
    }
    
    // Si no tiene código de país, formatear en grupos de 3
    const formatted = cleaned.match(/.{1,3}/g)?.join(' ') || cleaned;
    return formatted;
  }

}
